import { render, staticRenderFns } from "./RecrutamentoCoordMkt.vue?vue&type=template&id=76edd49f&scoped=true"
import script from "./RecrutamentoCoordMkt.vue?vue&type=script&lang=js"
export * from "./RecrutamentoCoordMkt.vue?vue&type=script&lang=js"
import style0 from "./RecrutamentoCoordMkt.vue?vue&type=style&index=0&id=76edd49f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76edd49f",
  null
  
)

export default component.exports